<script setup lang="ts">
import { Button } from 'primevue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ConnectWallet from './ConnectWallet.vue'
import { routerList } from './constant'
import MobileHeader from './MobileHeader.vue'
import SwitchChainButton from './SwitchChainButton.vue'

const router = useRouter()
const route = useRoute()

const activeRouter = computed(() => {
  console.log(route, 'route')
  return routerList.find((item) => {
    if (route.query?.type) {
      return route.query.type === item.query?.type && item.path.includes(route.path)
    }
    else {
      return item.path === route.path
    }
  })
})
// function toggleLanguage() {
//   const newLocale = locale.value === 'en' ? 'zh' : 'en'
//   locale.value = newLocale
//   localStorage.setItem('language', newLocale)
// }
</script>

<template>
  <header
    class="hidden flex-col items-center justify-between rounded-[24px] border-2 border-black bg-black pl-4 shadow-sm lg:flex lg:flex-row"
  >
    <div class="flex items-center gap-3">
      <img
        src="@img/common/logo-white.png"
        alt="Astar"
        class="h-8 cursor-pointer"
        @click="router.push('/')"
      />
    </div>

    <div
      class="ml-1 flex h-[60px] flex-1 items-center justify-between rounded-r-[22px] bg-[#FAF8F6] px-4"
    >
      <div class="flex gap-1">
        <Button
          v-for="item in routerList"
          :key="item.label"
          :label="item.label"
          severity="secondary"
          class="btn h-[45px] rounded-[12px] border-none bg-[#FAF8F6] text-gray-700"
          :class="{ active: item.path === activeRouter?.path }"
          :rounded="true"
          @click="router.push(item.path)"
        />
      </div>
      <div class="flex items-center gap-3">
        <SwitchChainButton />

        <ConnectWallet />

        <!-- <Button
    :label="locale === 'en' ? 'EN' : 'ZH'"
    variant="outlined"
    class="p2 border-2 border-black bg-transparent font-medium text-black"
    :rounded="true"
    @click="toggleLanguage"
  /> -->
      </div>
    </div>
  </header>
  <div class="lg:hidden">
    <MobileHeader />
  </div>
</template>

<style scoped lang="less">
:deep(.p-inputtext) {
  padding: 0.5rem 1rem 0.5rem 2.5rem;
}

:deep(.btn) {
  color: #171717cc;
  &.active {
    .p-button-label {
      color: #000000e5;
      font-weight: 700;
    }
  }
}
:deep(.p-input-icon-left > i:first-of-type) {
  left: 1rem;
}
</style>
